module.exports = __webpack_public_path__ + "media/images/icons/outlined/up-square-dcbdc274f3a72f04561508ac390b992e.svg";